import graphqlClient from "../../../apollo";

class GoogleProvider {

    googleGeocode(address, localityFilter) {
        return graphqlClient.query({
            query: require('./gql/Google/googleGeocode.graphql'),
            variables: {address, localityFilter}
        })
    }


    googleDistanceMatrix(origin, destination) {
        return graphqlClient.query({
            query: require('./gql/Google/googleDistanceMatrix.graphql'),
            fetchPolicy: "network-only",
            variables: {origin, destination}
        })
    }


    googleStreetViewImage({latitude, longitude}) {
        return graphqlClient.query({
            query: require('./gql/Google/googleStreetViewImage.graphql'),
            variables: {latitude, longitude},
            fetchPolicy: "network-only"
        })
    }

}

export default new GoogleProvider()


